<template>
  <ion-app>
    <ion-content>
      <ion-grid>
        <p class="page-title">Suporte</p>
        <ion-row>
          <ion-col size="12">
            <div class="support-block">
              <div class="support-padding">
                <p class="mt-0 mb-0 bold text-xl green">Perguntas frequentes</p>
                <div class="faq mt-4">
                  <div class="faq-item mb-4 cursor-pointer" @click="tapQuestion('q1')">
                    <div class="faq-question">
                      <p class="mt-0 mb-0 text-md dark">Como são criadas as dietas?</p>
                      <ion-icon mode="ios" :name="q1.icon" class="faq-icon"></ion-icon>
                    </div>
                    <div v-if="q1.open" class="faq-answer">
                      <p
                        class="mt-3 mb-0 darkgrey text-sm"
                      >Nosso algoritmo calcula seu plano de nutrição levando em consideração todas as informações que você nos fornece sobre si e vai aprendendo com seu uso e feedback para torná-lo cada vez mais eficiente e prazeroso.</p>
                    </div>
                  </div>
                  <div class="faq-item mb-4 cursor-pointer" @click="tapQuestion('q2')">
                    <div class="faq-question">
                      <p class="mt-0 mb-0 text-md dark">Como trocar uma refeição que não gostei?</p>
                      <ion-icon mode="ios" :name="q2.icon" class="faq-icon"></ion-icon>
                    </div>
                    <div v-if="q2.open" class="faq-answer">
                      <p
                        class="mt-3 mb-0 darkgrey text-sm"
                      >Na página da refeição, clique em "Alternativas". O app buscará receitas equivalentes que você pode selecionar em seguida.</p>
                    </div>
                  </div>
                  <div class="faq-item mb-4 cursor-pointer" @click="tapQuestion('q3')">
                    <div class="faq-question">
                      <p class="mt-0 mb-0 text-md dark">Como altero minhas opções de dieta?</p>
                      <ion-icon mode="ios" :name="q3.icon" class="faq-icon"></ion-icon>
                    </div>
                    <div v-if="q3.open" class="faq-answer">
                      <p
                        class="mt-3 mb-0 darkgrey text-sm"
                      >Vá até a página de perfil e na parte inferior clique em "Editar dieta". No mesmo canto você também encontra os lugares para editar informações sobre seu corpo, suas restrições e preferências. Para alterar o objetivo da dieta, vá na página de progresso e clique em "Meu objetivo".</p>
                    </div>
                  </div>
                  <div class="faq-item mb-4 cursor-pointer" @click="tapQuestion('q4')">
                    <div class="faq-question">
                      <p class="mt-0 mb-0 text-md dark">Não estou perdendo peso. Por que?</p>
                      <ion-icon mode="ios" :name="q4.icon" class="faq-icon"></ion-icon>
                    </div>
                    <div v-if="q4.open" class="faq-answer">
                      <p
                        class="mt-3 mb-0 darkgrey text-sm"
                      >Perder peso é uma conquista que envolve seguir a dieta com disciplina e possivelmente também realizar atividades físicas em paralelo. Às vezes os primeiros resultados levam algum tempo para aparecer. Não se desanime e mantenha o foco!</p>
                    </div>
                  </div>
                  <div class="faq-item mb-4 cursor-pointer" @click="tapQuestion('q5')">
                    <div class="faq-question">
                      <p class="mt-0 mb-0 text-md dark">Quanto tempo leva até atingir meu objetivo?</p>
                      <ion-icon mode="ios" :name="q5.icon" class="faq-icon"></ion-icon>
                    </div>
                    <div v-if="q5.open" class="faq-answer">
                      <p
                        class="mt-3 mb-0 darkgrey text-sm"
                      >Depende do seu objetivo e de você. As dietas do Updiet são super otimizadas para obter resultados o mais rápido possível, mas é importante segui-las com disciplina e acompanhadas de atividades físicas.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ion-col>
        </ion-row>
        <div class="support-links">
          <div class="settings-item-top mt-0 mb-0 cursor-pointer" @click="gotoLegal">
            <ion-item lines="none">
              <ion-label>
                <p class="mt-0 mb-0 bold text-md">Privacidade &amp; Termos</p>
              </ion-label>
              <ion-icon mode="ios" name="arrow-forward" slot="end" color="medium"></ion-icon>
            </ion-item>
          </div>
          <div class="settings-item mt-0 mb-0 cursor-pointer">
            <ion-item lines="none">
              <ion-label>
                <p class="mt-0 mb-0 bold text-md">Enviar email ao suporte</p>
                <p class="mt-0 mb-0 bold dark text-sm">suporte@updiet.com.br</p>
              </ion-label>
            </ion-item>
          </div>
        </div>
        <div class="back-button-bg" @click="gotoBack">
          <ion-icon mode="ios" name="arrow-back" size="large" class="white"></ion-icon>
        </div>
      </ion-grid>
    </ion-content>
  </ion-app>
</template>

<script>
export default {
  name: "SupportPage",
  data() {
    return {
      q1: {
        open: false,
        icon: "arrow-forward"
      },
      q2: {
        open: false,
        icon: "arrow-forward"
      },
      q3: {
        open: false,
        icon: "arrow-forward"
      },
      q4: {
        open: false,
        icon: "arrow-forward"
      },
      q5: {
        open: false,
        icon: "arrow-forward"
      }
    };
  },
  methods: {
    gotoBack() {
      this.$router.go(-1);
    },
    gotoLegal() {
      this.$router.push({
        name: "Legal"
      });
    },
    gotoTicket() {
      this.$router.push("/mytickets");
    },
    tapQuestion(q) {
      if (q === "q1") {
        if (this.q1.open) {
          this.q1 = {
            open: false,
            icon: "arrow-forward"
          };
        } else {
          this.q1 = {
            open: true,
            icon: "arrow-down"
          };
        }
      } else if (q === "q2") {
        if (this.q2.open) {
          this.q2 = {
            open: false,
            icon: "arrow-forward"
          };
        } else {
          this.q2 = {
            open: true,
            icon: "arrow-down"
          };
        }
      } else if (q === "q3") {
        if (this.q3.open) {
          this.q3 = {
            open: false,
            icon: "arrow-forward"
          };
        } else {
          this.q3 = {
            open: true,
            icon: "arrow-down"
          };
        }
      } else if (q === "q4") {
        if (this.q4.open) {
          this.q4 = {
            open: false,
            icon: "arrow-forward"
          };
        } else {
          this.q4 = {
            open: true,
            icon: "arrow-down"
          };
        }
      } else {
        if (this.q5.open) {
          this.q5 = {
            open: false,
            icon: "arrow-forward"
          };
        } else {
          this.q5 = {
            open: true,
            icon: "arrow-down"
          };
        }
      }
    }
  }
};
</script>

<style scoped>
ion-app {
  background: linear-gradient(
    180deg,
    var(--ion-color-primary),
    var(--bg-color-light),
    var(--bg-color-light)
  ) !important;
}
ion-content {
  --background: transparent !important;
  --padding-bottom: 5px !important;
}
ion-grid {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
ion-col {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.support-block {
  margin-top: 80px;
  width: 100%;
  padding-top: 40px;
  padding-bottom: 20px;
  margin-bottom: 20px;
  box-shadow: 0 -6px 6px -6px rgba(0, 0, 0, 0.15);
  background: white;
}
.support-padding {
  padding-left: 10vw;
  padding-right: 10vw;
}
.faq-question {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.faq-icon {
  font-size: 1.3rem;
}
.settings-item-top ion-item {
  --background: white !important;
  --padding-top: 10px !important;
  --padding-bottom: 10px !important;
}
.settings-item ion-item {
  --background: white !important;
  --padding-top: 10px !important;
  --padding-bottom: 10px !important;
}
.settings-item-top {
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
}
.settings-item {
  border-bottom: 1px solid #eeeeee;
}
</style>
